// extracted by mini-css-extract-plugin
export default {"photosSec":"Photos_photosSec__WBP9R","photosSecFirst":"Photos_photosSecFirst__pPbwW","photosWarn":"Photos_photosWarn__OIt8p","photosUpload":"Photos_photosUpload__NKH1L"};